module.exports = __webpack_public_path__ + "images/feature/feature_1027_2-766d7c821759c1c2969f33cf47a36726.png";